import axios from 'axios';
import forEach from 'lodash/forEach';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationDE from './i18n/de.json';
import translationEN from './i18n/en.json';

interface TranslationsAPI {
  de: string;
  en: string;
}

const resources = {
  de: {
    translation: translationDE
  },
  en: {
    translation: translationEN
  }
};

const backendLanguage = (): Promise<void> => {
  return axios
    .get(
      (process.env.REACT_APP_API_UCF || '')
        .toString()
        .replace('Forms', 'Translations')
    )
    .then((response) => {
      const translationsEn: { [key: string]: string } = {};
      const translationsDe: { [key: string]: string } = {};
      forEach(response.data, (value: TranslationsAPI, key: string) => {
        if (value && value.en) {
          translationsEn[key] = value.en;
        }
        if (value && value.de) {
          translationsDe[key] = value.de;
        }
      });

      i18n.removeResourceBundle('en', 'translation');
      i18n.addResourceBundle('en', 'translation', translationsEn, true, true);
      i18n.removeResourceBundle('de', 'translation');
      i18n.addResourceBundle('de', 'translation', translationsDe, true, true);
      i18n.changeLanguage(i18n.language);
    });
};

const getLanguage = (
  locale: string | undefined,
  location: string | undefined
): string | undefined => {
  if (location && /lang=en/.test(location)) {
    return 'en';
  }

  if (location && /lang=de/.test(location)) {
    return 'de';
  }

  if (locale) {
    return locale;
  }

  return 'de';
};

export const init18n = (
  locale: string | undefined,
  location: string | undefined
): void => {
  const lang = getLanguage(locale, location);
  i18n.use(initReactI18next).init(
    {
      resources,
      lng: lang,
      fallbackLng: lang,
      keySeparator: '.',
      nsSeparator: '|',
      interpolation: {
        escapeValue: false
      },
      react: { wait: true }
    },
    backendLanguage
  );
  return undefined;
};

export default i18n;
